// ParentsListWindow.js

import { Box, Button, TextInput, Layer, Text,  Spinner, RadioButton} from "grommet";
import { useState, useEffect, useCallback, useMemo, useRef, useContext } from "react";
import { CircleInformation } from "grommet-icons";
import { useFetch } from "use-http";
import { useNavigate } from "react-router-dom";
import { FixedSizeList as List } from "react-window";
import debounce from 'lodash.debounce';
import { getDBURL, usePopupFocus } from "../Utils/Utils";
import useTrapFocus from "../Utils/useTrapFocus";
import Notification from "./Notification";
import VineCharacteristics from  "./VineCharacteristics";
import { UserContext } from "../../App";
import { useErrorLogger } from './Logger';

const ParentsListWindow = (props) => {
    const {parentsList, searchValue, prevParent, changeParent, onClose} = props;
    console.log('ParentsListWindow props  >>  ', props);
    // console.log('In ParentsListWindow parentsList >> ', parentsList);
    
    const [parents, setParents] = useState([]);
    const [filteredList, setFilteredList] = useState([]);
    const currentUser = useContext(UserContext);
    const [showError, setShowError] = useState(false);
    const [notificationMessage, setNotificationMessage] = useState("");

    // console.log('parentsList in ParentsListWindow >> ', parentsList);
    // console.log('varietiesList in ParentsListWindow >> ', varietiesList);
    // console.log('plantInfo >> ', props.plantInfo);
    // const navigate = useNavigate();
    const { loading } = useFetch(getDBURL());
    const [selectedCultivar, setSelectedCultivar] = useState({ cId: prevParent.Id, cName: prevParent.Name, cDisplayName: prevParent.DisplayName, cObjectType: prevParent.ObjectType, cCultivarId: prevParent.CultivarId, cRootstockId: prevParent.RootstockId, Rootstock: prevParent.Rootstock});
    const [searchInput, setSearchInput] = useState(searchValue); 
    const [showDetails, setShowDetails] = useState(false);
    const [characteristicsToShow, setCharacteristicsToShow] = useState(null);

    const { get } = useFetch(getDBURL());
    const { DBlogError } = useErrorLogger();
    // Manage focus when opening modal windows
    usePopupFocus(showDetails, "vine-char"); 

    // Ref for the modal and focus trap to keep focus within it  
    const modalRef = useRef(null);
    useTrapFocus(modalRef, true); // Trap focus inside the modal while it's open

    useEffect(() => {
        async function loadData() {
            setParents(parentsList);
        }
    
        loadData();
    }, []); // Fetch data on mount
    

    useEffect(() => {
        if (parents.length > 0) {
            if (searchValue !== '')
                searchItems(searchValue);
            else
                setFilteredList(parents);
        }
    }, [parents]);

    // if arr length > 0 and cultivar found returns cultivar object
    // otherwise returns undefined
    const getCultivarById = (arr, objectType, id) => {
        if (!id || id === '00000000-0000-0000-0000-000000000000') {
            return { cId: '00000000-0000-0000-0000-000000000000', cName: '', cObjectType: 0 };
        }
        return arr?.find(element => element.cObjectType === objectType && element.cId === id) ?? null;
    };


    const loadCultivarData = async (cultivarId) => {
        // Reset notifications
        setShowError(false);
        setNotificationMessage("");

        try {
            const response = await get("/loadCultivar/cultivarId=" + cultivarId + "/dt=" + Date.now())

            // Check if the response is successful
            if (!response.success) {
                throw new Error(`HTTP error! ${response.message}`);
            }
    
            const data = response.result;
            // console.log("loaded Cultivar values:", data[0]);
            if( data !== undefined && data !== "" && data.length > 0) {
                // console.log("loaded Cultivar values:", data[0]);
                setCharacteristicsToShow(data[0]); 
            }
            return true;
        } catch (error) {
            console.error(' 🔴 Error in f-n loadCultivarData >> ', error.message);
            setShowError(true);
            setNotificationMessage(' An error occurred in load Cultivar Data!!');
            
            // Construct error object
            await DBlogError({
                error: error,
                parameters: { cultivarId: cultivarId, },
                userName: currentUser.email,
                moduleName: 'ParentsListWindow',
                functionName: 'loadCultivarData',
            });

            return false;           
        }  
    };

    /* Applies a debounced search to the parents list, executing the filter operation 300ms after the user stops typing. 
        ▫️ useCallback( ... , [parents]): This hook is used to memoize the searchItems function. 
            This means that the function will only be recreated if the parents dependency changes. 
            This optimization prevents unnecessary re-renders.
        ▫️ debounce((newValue) => { ... }, 300): The debounce function 
            ensures that the provided callback function is only executed after a 300 millisecond pause in input. 
            This avoids triggering a search on every keyspress, enhancing performance.
     
        Function filters the list to include items where DisplayName contains the input text (case-insensitive), 
        while safely handling cases where DisplayName is undefined or null. 
        Updates the filtered list with matching results or resets it to the full list if the input is empty.   **/
    const searchItems = useCallback(
        debounce((newValue) => {
          if (newValue !== '') {
            const filteredData = parents.filter((item) =>
                item.DisplayName && item.DisplayName.toLowerCase().includes(newValue.toLowerCase())
            );
            setFilteredList(filteredData);
          } else {
            setFilteredList(parents);
          }
        }, 300), // Debounce with 300ms
        [parents]
    );

    const handleSearchChange = (e) => {
        const newValue = e.target.value;
        setSearchInput(newValue);
        searchItems(newValue);
    };

    const changeChecked = (cultivar) => {
        setSelectedCultivar((prev) => 
            prev?.cId === cultivar.Id
                ? { cId: '00000000-0000-0000-0000-000000000000', cName: "", cDisplayName: "", cObjectType: 0, cCultivarId: null, cRootstockId: '00000000-0000-0000-0000-000000000000', cRootstock: "" }
                : { cId: cultivar.Id, cName: cultivar.Name, cDisplayName: cultivar.DisplayName, cObjectType: cultivar.ObjectType, cCultivarId: cultivar.CultivarId, cRootstockId: cultivar.RootstockId, cRootstock: cultivar.Rootstock }
        );
    };
   

    const openDetails = async (item) => {
        // console.log('In openDetails item: >>>>  ', item);
        let cultivarId;
        
        if (item.ObjectType === 2) {
            // 2 - station
            cultivarId = item.CultivarId;
        }
        else {
            // 1 - cultivar
            cultivarId = item.Id;
        }
        const res = await loadCultivarData(cultivarId);
        if (res) setShowDetails(true);
    };    
   
    const DrawRow = ({ index, style }) => {
        const cultivar = filteredList[index];
        return (
            <Box
                key={cultivar.Id}
                direction="row-responsive"
                align="center"
                justify="between"
                margin="xsmall"
                border
                style={{ ...style, maxWidth: "98%" }}
            >
                <Box width="3%" align="center" margin="medium">
                <RadioButton
                    name="radio"
                    checked={selectedCultivar && cultivar.Id === selectedCultivar.cId}
                    onClick={() => changeChecked(cultivar)}
                    onChange={() => {}}
                />
                </Box>
                <Box width="90%" height="100%" pad="medium">
                    <Box width="100%">
                        <Text
                        weight="bold"
                        style={{
                            background: "linear-gradient(to left, #00739D, #f9dd94 100%)",
                            backgroundPosition: "0 100%",
                            backgroundSize: "100% 2px",
                            backgroundRepeat: "repeat-x",
                            fontStyle: "italic"
                        }}
                        >
                        {cultivar.DisplayName}
                        </Text>
                    </Box>
                    <Box width="100%" direction="row-responsive" style={{ paddingTop: "10px" }}>
                        <Box width="60%" direction="row">
                            <Text> mother: </Text>
                            <Text weight="bold" style={{ fontStyle: "italic" }}>{cultivar.Mother}</Text>
                        </Box>
                        <Box width="40%" direction="row">
                            <Text> father: </Text>
                            <Text weight="bold" style={{ fontStyle: "italic" }}>{cultivar.Father}</Text>
                        </Box>
                    </Box>
                    <Box width="100%" direction="row-responsive">
                        <Box width="60%" direction="row">
                            <Text> rootstock: </Text>
                            <Text weight="bold" style={{ fontStyle: "italic" }}>{cultivar.Rootstock}</Text>
                        </Box>
                        <Box width="40%" direction="row">
                            <Text> row: </Text>
                            <Text weight="bold" style={{ fontStyle: "italic" }}>{cultivar.StationRow}</Text>
                        </Box>
                    </Box>
                </Box>
                <Box width="3%" align="center" justify="center" margin="medium">
                    <Button
                        icon={<CircleInformation color="brand" />}
                        onClick={()=>openDetails(cultivar)}
                    />
                </Box>
            </Box>
        );
      };
    
    // The DrawRow component is memoized to avoid unnecessary re-renders.
    const RowMemo = useMemo(() => DrawRow, [filteredList, selectedCultivar]);    

    return (   
        <Layer
            id="parents-lst"
            ref={modalRef}
            tabIndex="-1"
            position="center"
            onEsc={onClose}
            onClickOutside={onClose}
            responsive
            modal
         >
            {showError && (
                <Notification
                status="critical"
                message={`${notificationMessage}`}
                onClose={() => setShowError(false)}
                />
            )}            
            {loading && (
            <Box align="center" direction="row" gap="small" pad="small">
                <Spinner /> <Text>Loading...</Text>
            </Box>
            )}

            <Box 
                width="900px"
                height="100%" 
                style = {{
                    border: "2px solid",       
                    margin: "10px",
                }} 
                pad="small"  background="light-3"  >
                <Box style={{ padding: "10px 10px 0 10px"}} >
                    <Text weight="bold" >Enter cultivar name:</Text>

                    <Box pad={{ vertical: "small" }}  direction="row-responsive" justify="between" >
                        <Box pad={{ vertical: "xsmall" }} width="100%">
                        <TextInput
                        placeholder="Search..."                  
                        value={searchInput}
                        style={{ padding: "1px 0 1px 10px", background: "white"}}                
                        // onChange={(e) => searchItems(e.target.value)}                                
                        onChange={handleSearchChange}
                            /> 
                        </Box>                     
                    </Box>     

                    <Box background="neutral-3" height="2px" margin={{vertical: "xxsmall"}}> </Box>                  
                </Box>

                {/* start table */}
                <Box width='97%' 
                    margin="small" 
                    pad="small"
                    // height="650px"
                    height="100%"
                    border>

                    <Box align='center' background='light-1' overflow='auto'  >
                        <List
                            height={600}
                            itemCount={filteredList.length}
                            itemSize={150}
                            width="100%"
                            >
                            {RowMemo}
                        </List>

                    </Box>

                </Box>
                {/* end table */}

                <Box align="center" direction="row" gap="small" pad="small" justify="around">
                    <Button primary style={{color: "#ffffff"}} label="Ok" onClick={()=>{ changeParent(selectedCultivar); onClose();}} />
                    <Button secondary label="Cancel" onClick={onClose} />
                </Box>

                {showDetails && 
                <Layer
                    id="danger-msg"
                    position="center"
                    style={{
                        backgroundColor: 'rgba(0, 0, 0, 0.5)', // Dim background for modal effect
                    }}              
                    onEsc={()=>setShowDetails(false)}
                    onClickOutside={() => {}}
                    >
                    <Box 
                        overflow='auto'
                        pad="small" 
                        gap="small" 
                        width="large"  
                        background="white"  
                        
                        style={{
                            position: 'relative',
                            margin: 'auto', // Center horizontally and vertically
                        }}
                    >  
                        <Box
                            pad="small" // Padding to create space for the white border
                            background="#ebf6fa" // White border
                            border={{ color: "brand"}}
                            >
                            <VineCharacteristics cultivarData={characteristicsToShow} setCultivarData={()=>{}} readOnly={true} />
                            <Box  width="100%"  align="center" justify="center" margin="medium" >
                                <Button secondary label="Close"
                                    onClick={()=>setShowDetails(false)}
                                />                 
                            </Box>  
                        </Box>
                    </Box>
                </Layer>
                }
            </Box>
        </Layer>
    );
  };
  
  export default ParentsListWindow;

